export const PRIVATE_BETA_PATH = "/private-beta";

export const getReleaseAccessRedirectPath = (input: {
  accessRequired: boolean;
  allowed: boolean | undefined;
  currentPath: string;
}): string | null => {
  if (!input.accessRequired || input.allowed !== false || input.currentPath === PRIVATE_BETA_PATH) {
    return null;
  }

  return PRIVATE_BETA_PATH;
};
